import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import Decimal from 'decimal.js';
import { useFormContext } from 'react-hook-form';
import { Column, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { BundlePriceEditorContent } from '~/components/BundlePriceEditor';
import DiscountInput from '~/components/ServiceBuilder/DiscountInput';
import MinPriceTextField from '~/components/ServiceBuilder/MinPriceTextField';
import PriceTextField from '~/components/ServiceBuilder/PriceTextField';
import { getPriceAfterDiscount } from '~/components/ServiceBuilder/ServiceBuilder.utils';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { DiscountModel, DiscountType, serviceModel } from '~/models';
import { ServiceCostType } from '~/models/service-cost';
export const GetServiceRateModalContentTID = (parentTestId)=>getTestIds(parentTestId);
export const ServiceRateModalContentOld = (param)=>{
    let { service, draft, setDraft, testId } = param;
    const { SERVICE_TEMPLATE_BUNDLE } = useFeatureFlags();
    const isBundle = Boolean(SERVICE_TEMPLATE_BUNDLE && serviceModel.isBundle(service));
    const { watch } = useFormContext();
    const [pricing, price, minPrice, discount] = watch([
        'pricing',
        'price',
        'minPrice',
        'discount'
    ]);
    const discountedPrice = useMemo(()=>getPriceAfterDiscount({
            pricing,
            price,
            minPrice,
            discount
        }), [
        pricing,
        price,
        minPrice,
        discount
    ]);
    const changeService = (transformer)=>{
        setDraft(draft.setService(service.id, transformer));
    };
    const serviceData = useMemo(()=>draft.service(service.id), [
        draft,
        service.id
    ]);
    if (isBundle) {
        var _serviceData_bundle;
        return /*#__PURE__*/ _jsx(BundlePriceEditorContent, {
            service: service,
            showActions: false,
            data: {
                bundleRate: (serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.pricingType) === ServiceCostType.Fixed || (serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.pricingType) === ServiceCostType.Variable ? (serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.price.toNumber()) || 0 : 0,
                discount: (serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.discount) ? serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.discount.amount().toNumber() : '',
                discountType: (serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.discount) ? serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.discount.type() : DiscountType.Percent,
                includedServiceRates: (serviceData === null || serviceData === void 0 ? void 0 : (_serviceData_bundle = serviceData.bundle) === null || _serviceData_bundle === void 0 ? void 0 : _serviceData_bundle.services.reduce((acc, s)=>{
                    acc[s.serviceTemplateId || ''] = +s.rate;
                    return acc;
                }, {})) || {}
            },
            onDataChange: (param)=>{
                let { bundleRate, discount, discountType, includedServiceRates } = param;
                return changeService((s)=>{
                    var _serviceData_bundle;
                    return _object_spread_props(_object_spread({}, s), {
                        cost: _object_spread_props(_object_spread({}, s.cost), {
                            price: new Decimal(bundleRate),
                            discount: +discount >= 0 ? DiscountModel.make(discountType, +discount) : null
                        }),
                        bundle: _object_spread_props(_object_spread({}, s.bundle), {
                            services: (serviceData === null || serviceData === void 0 ? void 0 : (_serviceData_bundle = serviceData.bundle) === null || _serviceData_bundle === void 0 ? void 0 : _serviceData_bundle.services.map((bs)=>_object_spread_props(_object_spread({}, bs), {
                                    rate: new Decimal(includedServiceRates[bs.serviceTemplateId || ''])
                                }))) || []
                        })
                    });
                });
            }
        });
    }
    const testIds = useMemo(()=>GetServiceRateModalContentTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 16,
        testId: testIds.ServiceRateModalContentTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsxs(Column, {
                gap: 16,
                children: [
                    pricing === 'range' && /*#__PURE__*/ _jsx(MinPriceTextField, {
                        testId: "edit-service-rate-modal-min-price",
                        onChange: (value)=>changeService((s)=>_object_spread_props(_object_spread({}, s), {
                                    cost: _object_spread_props(_object_spread({}, s.cost), {
                                        minPrice: new Decimal(value || 0)
                                    })
                                }))
                    }),
                    /*#__PURE__*/ _jsx(PriceTextField, {
                        testId: "edit-service-rate-modal-price",
                        onChange: (value)=>changeService((s)=>_object_spread_props(_object_spread({}, s), {
                                    cost: _object_spread({}, s.cost, pricing === 'range' ? {
                                        maxPrice: new Decimal(value || 0)
                                    } : {
                                        price: new Decimal(value || 0)
                                    })
                                }))
                    }),
                    /*#__PURE__*/ _jsx(DiscountInput, {
                        testId: "edit-service-rate-modal-discount",
                        onChange: (value)=>changeService((s)=>_object_spread_props(_object_spread({}, s), {
                                    cost: _object_spread_props(_object_spread({}, s.cost), {
                                        discount: +value.amount ? DiscountModel.make(value.type, +value.amount) : null
                                    })
                                }))
                    })
                ]
            }),
            discountedPrice && /*#__PURE__*/ _jsxs(Typography, {
                testId: testIds.ServiceRateModalContentTestIds.DiscountedPrice(),
                style: {
                    marginTop: -4
                },
                children: [
                    "Price after discount: ",
                    discountedPrice
                ]
            })
        ]
    });
};
